import React from 'react';

const InputField = ({ 
  label, 
  type = "text", 
  placeholder, 
  value, 
  onChange, 
  isDark, 
  icon: Icon,
  className = "",
  ...props 
}) => {
  return (
    <div className={`w-full space-y-2 ${className}`}>
      {label && (
        <label className={`block text-[11px] font-black uppercase tracking-widest ml-1 ${
          isDark ? 'text-slate-400' : 'text-slate-500'
        }`}>
          {label}
        </label>
      )}
      
      <div className="relative group">
        {Icon && (
          <div className={`absolute left-4 top-1/2 -translate-y-1/2 transition-colors duration-300 ${
            isDark ? 'text-slate-500 group-focus-within:text-indigo-400' : 'text-slate-400 group-focus-within:text-indigo-500'
          }`}>
            <Icon size={18} />
          </div>
        )}
        
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`
            w-full px-4 py-3 rounded-xl border-2 outline-none transition-all duration-300 font-brand-body text-sm
            ${Icon ? 'pl-12' : 'pl-4'}
            ${isDark 
              ? 'bg-slate-950 border-slate-800 text-slate-100 placeholder:text-slate-600 focus:border-indigo-500/50 focus:bg-slate-900' 
              : 'bg-slate-50 border-slate-100 text-slate-900 placeholder:text-slate-400 focus:border-indigo-500/30 focus:bg-white focus:shadow-sm'
            }
          `}
          {...props}
        />
      </div>
    </div>
  );
};

export default InputField;